import memberPurchasesTemplate from './member_purchases.html';

function MemberPurchasesCtrl($scope, $q, $log, LoadingService, BBModel) {
    'ngInject';

    $scope.getPurchases = function () {
        const loader = LoadingService.$loader($scope).notLoaded();
        const defer = $q.defer();
        BBModel.Member.Purchase.$query($scope.member, {}).then((purchases) => {
                $scope.purchases = purchases;
                loader.setLoaded();
                return defer.resolve(purchases);
            }
            , (err) => {
                $log.error(err.data);
                loader.setLoaded();
                return defer.reject([]);
            });

        return defer.promise;
    };
}

function MemberPurchasesDirective($rootScope, PaginationService) {
    'ngInject';

    function link(scope, element, attrs) {

        scope.member = scope.$eval(attrs.member);
        if ($rootScope.member) {
            if (!scope.member) {
                scope.member = $rootScope.member;
            }
        }

        scope.pagination = PaginationService.initialise({page_size: 10, max_size: 5});

        return $rootScope.connection_started.then(() => {
            if (scope.member) {
                return scope.getPurchases().then(purchases => PaginationService.update(scope.pagination, purchases.length));
            }
        });
    }

    return {
        templateUrl: memberPurchasesTemplate.id,
        scope: true,
        controller: MemberPurchasesCtrl,
        link
    };

}

angular
    .module('BBMember')
    .directive('bbMemberPurchases', MemberPurchasesDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/member-purchases/member_purchases.directive.js